export default "__VITE_ASSET__CtTeC7W5__"